import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [

  {
    path: '',
    loadChildren: '@app/modules/home/home.module#HomeModule'
  },
  {
    path: 'modes',
    loadChildren: '@app/modules/order-type/order-type.module#OrderTypeModule'
  },
  {
    path: 'carte',
    loadChildren: '@app/modules/carte/carte.module#CarteModule'
  },
  {
    path: 'checkout',
    loadChildren: '@app/modules/checkout/checkout.module#CheckoutModule'
  },
  {
    path: 'compte',
    loadChildren: '@app/modules/authentification/authentification.module#AuthentificationModule'
  },
  {
    path: 'restaurant',
    loadChildren: '@app/modules/restaurant/restaurant.module#RestaurantModule'
  },
  {
    path: 'commandes',
    loadChildren: '@app/modules/orders/orders.module#OrdersModule'
  },
  {
    path: 'contact',
    loadChildren: '@app/modules/contact/contact.module#ContactModule'
  },

  {
    path: 'cgv',
    loadChildren: '@app/modules/cgv/cgv.module#CgvModule'
  },

  {
    path: 'mentions-légales',
    loadChildren: '@app/modules/legal-notice/legal-notice.module#LegalNoticeModule'
  },
  {
    path: 'confirmation-payement',
    loadChildren: '@app/modules/confirmation-payement/confirmation-payement.module#ConfirmationPayementModule'
  },
  {
    path: 'commander/:zone',
    loadChildren: '@app/modules/zone/zone.module#ZoneModule'
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
